
export const auth = {
  signIn: 'Iniciar Sesión',
  signUp: 'Crear Cuenta',
  email: 'Email',
  password: 'Contraseña',
  confirmPassword: 'Confirmar Contraseña',
  forgotPassword: '¿Olvidaste la contraseña?',
  noAccount: '¿No tienes una cuenta?',
  hasAccount: '¿Ya tienes una cuenta?',
  signInWithGoogle: 'Iniciar sesión con Google',
  signUpWithGoogle: 'Registrarse con Google',
  resetPassword: 'Restablecer Contraseña',
  backToSignIn: 'Volver al Inicio de Sesión',
  resetEmailSent: 'Email de restablecimiento enviado',
  invalidCredentials: 'Email o contraseña inválidos',
  emailAlreadyExists: 'Ya existe una cuenta con este email',
  passwordTooWeak: 'La contraseña debe tener al menos 6 caracteres',
  genericError: 'Ocurrió un error. Inténtalo de nuevo.',
  signInSuccess: '¡Inicio de sesión exitoso!',
  signUpSuccess: '¡Cuenta creada exitosamente!',
  signOutSuccess: '¡Sesión cerrada exitosamente!',
  fullName: 'Nombre Completo',
  companyName: 'Nombre de la Empresa',
  companySize: '¿Cuántas personas trabajan en la empresa?',
  organization: 'Organización (Opcional)',
  department: 'Departamento (Opcional)',
  position: 'Posición (Opcional)',
  phone: 'Teléfono (Opcional)',
  createAccount: 'Crear Cuenta',
  alreadyRegistered: '¿Ya estás registrado?',
  newPassword: 'Nueva Contraseña',
  updatePassword: 'Actualizar Contraseña',
  passwordUpdated: '¡Contraseña actualizada exitosamente!',
  resetEmailInstructions: 'Ingresa tu dirección de email y te enviaremos un enlace para restablecer tu contraseña.',
  sendResetEmail: 'Enviar Email de Restablecimiento',
  enterNewPassword: 'Ingresa tu nueva contraseña abajo.',
  checkEmail: 'Revisa tu email para el enlace de restablecimiento de contraseña.'
};
